const getters = {
  addRouters: state => state.permission.addRouters,
  token: state => state.user.token,
  username: state => state.user.name,
  userFunction: state => state.user.userFunction,
  errorLogs: state => state.errorLog.logs
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js